import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const SHUGERT_PRO_INTAKE = "https://shugert.pro/admin/intake";

export const Route = createFileRoute("/admin/follow-up")({
  head: () => ({
    meta: [
      { title: "Commercial Follow-up moved · Shugert Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CommercialFollowUpRedirect,
});

function CommercialFollowUpRedirect() {
  useEffect(() => {
    window.location.replace(SHUGERT_PRO_INTAKE);
  }, []);

  return (
    <main style={{ padding: "2rem" }}>
      <h1>Commercial follow-up moved to Shugert.pro</h1>
      <p>Lead follow-up, comments, stages, archive state and communications are now managed centrally.</p>
      <p><a href={SHUGERT_PRO_INTAKE}>Open Commercial Intake</a></p>
    </main>
  );
}
